import React from 'react';
import { House, RotateCw, TriangleAlert } from 'lucide-react';
import EmptyState from './site/EmptyState';

/**
 * Last-resort screen for a crash while rendering. It can sit outside the router
 * (App.js wraps everything), so it navigates with plain page loads, not <Link>.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Error caught by boundary:', error, errorInfo);
    }
    this.setState({ errorInfo });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.assign('/');
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const { showDetails = false } = this.props;
    const details = showDetails && process.env.NODE_ENV === 'development';

    return (
      <main className="pk-page">
        <div className="pk-container pk-container--narrow">
          <EmptyState
            role="alert"
            icon={<TriangleAlert />}
            title="Something went wrong"
            text="This page ran into a problem. Reloading usually fixes it. If it keeps happening, please contact support."
            actions={
              <>
                <button type="button" className="pk-btn pk-btn--primary pk-btn--sm" onClick={this.handleReload}>
                  <RotateCw aria-hidden="true" /> Reload page
                </button>
                <button type="button" className="pk-btn pk-btn--secondary pk-btn--sm" onClick={this.handleGoHome}>
                  <House aria-hidden="true" /> Go to home
                </button>
              </>
            }
          />

          {details && (
            <details style={{ marginTop: 24, fontSize: 12 }}>
              <summary>Error details (development only)</summary>
              <pre style={{ whiteSpace: 'pre-wrap', overflowX: 'auto' }}>
                {String(this.state.error)}
                {this.state.errorInfo?.componentStack}
              </pre>
            </details>
          )}
        </div>
      </main>
    );
  }
}

export default ErrorBoundary;
